module.exports = __webpack_public_path__ + "img/icon_map_penguan_lixian.a612eb55.svg";